var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_feather-arrow-right","data-name":"Icon feather-arrow-right","transform":"translate(0 0.802)"},[React.createElement("path",{"id":"Path_595","data-name":"Path 595","d":"M7.5,18H34.725","transform":"translate(-7.5 -4.388)","fill":"none","stroke":"#f40","strokeLinejoin":"round","strokeWidth":"3","key":0}),React.createElement("path",{"id":"Path_596","data-name":"Path 596","d":"M18,7.5l8.612,13.612L18,34.725","transform":"translate(0.612 -7.5)","fill":"none","stroke":"#f40","strokeLinejoin":"round","strokeWidth":"3","key":1})]));
}

RightArrow.defaultProps = {"width":"28.725","height":"28.829","viewBox":"0 0 28.725 28.829"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
